import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import '../responsive.css';

// Importar imágenes de etiquetas desde landingEtiquetas/assets/img/
// Lado izquierdo (de arriba para abajo)
import diamanteHolografico from '../assets/img/diamanteHolografico.webp';
import stickerMetalico from '../assets/img/stickerMetalico.webp';
import jamon from '../assets/img/jamon.webp';

// Lado derecho (de arriba para abajo)
import transparente from '../assets/img/Transparente.webp';
import glowindarkAlien from '../assets/img/glowindarkAlien.webp';
import metalico_Crema from '../assets/img/Metalico_Crema.webp';

// Centro abajo
import cafe from '../assets/img/cafe.webp';

// Iconos de sectores
import iconoAlimentos from '../assets/img/icons/botelladeagua.png';
import iconoFarmaceutico from '../assets/img/icons/frascoconcruz.png';
import iconoAnimal from '../assets/img/icons/mascota.png';
import iconoBelleza from '../assets/img/icons/frascocosmetico.png';
import iconoManufacturero from '../assets/img/icons/engrane.png';
import iconoAutomotriz from '../assets/img/icons/automotriz.png';
import iconoIndustrial from '../assets/img/icons/industria.png';
import iconoVinos from '../assets/img/icons/botelladevino.png';
import iconoTextiles from '../assets/img/icons/textil.png';
import iconoPinturas from '../assets/img/icons/brocha.png';
import iconoOtros from '../assets/img/icons/estadio.png';

// Imágenes de características
import frascoImg from '../assets/img/caracteristicas/frasco.png';
import holograficoImg from '../assets/img/caracteristicas/holografico.png';

// Imágenes de sistemas de impresión
import flexoImg from '../assets/img/impresion/flexo.png';
import digitalImg from '../assets/img/impresion/digital.png';
import hibridaImg from '../assets/img/impresion/hibrida.png';

// Imágenes del footer
import isotipoImg from '../assets/img/isotipoMegaLabel.png';
import footerProductsImg from '../assets/img/footer.webp';

// Imágenes del carrusel
import img01 from '../assets/img/carousel/01-transparentes.png';
import img02 from '../assets/img/carousel/02-seguridad.png';
import img03 from '../assets/img/carousel/03-booklet.png';
import img04 from '../assets/img/carousel/04-metalizadas.png';
import img05 from '../assets/img/carousel/05-glowinthedark.png';
import img06 from '../assets/img/carousel/06-transferenciatermica.png';
import img07 from '../assets/img/carousel/07-stickers.png';
import img08 from '../assets/img/carousel/08-resellable.png';
import img09 from '../assets/img/carousel/09-scratchoff.png';
import img10 from '../assets/img/carousel/10-coldfoil.png';
import img11 from '../assets/img/carousel/11-conaroma.png';
import img12 from '../assets/img/carousel/12-holografico.png';
import img13 from '../assets/img/carousel/13-nylon.png';

gsap.registerPlugin(ScrollTrigger);

const LandingEtiquetas = () => {
  const heroRef = useRef(null);
  const labelsLeftRef = useRef([]);
  const labelsRightRef = useRef([]);
  const labelCenterRef = useRef(null);
  const carouselRef = useRef(null);
  const carouselContainerRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isMobileView, setIsMobileView] = useState(false);

  // Refs para la sección de características
  const caracteristicasTitleRef = useRef(null);
  const caracteristicasImageRef = useRef(null);
  const caracteristicasItemsRef = useRef([]);
  const caracteristicasCTARef = useRef(null);

  // Refs para la sección de sistemas de impresión
  const impresionTitleRef = useRef(null);
  const impresionCardsRef = useRef([]);
  const impresionCTARef = useRef(null);

  // Datos del carrusel
  const carouselData = [
    { img: img01, title: 'Transparentes', subtitle: 'Limpias, modernas y discretas.' },
    { img: img02, title: 'De Seguridad', subtitle: 'Protegen contra falsificaciones.' },
    { img: img03, title: 'Booklet', subtitle: 'Más información, mismo espacio.' },
    { img: img04, title: 'Metalizadas', subtitle: 'Brillo y elegancia inmediata.' },
    { img: img05, title: 'Glow in the Dark', subtitle: 'Brillan en la oscuridad.' },
    { img: img06, title: 'Transferencia Térmica', subtitle: 'Resistentes al calor extremo.' },
    { img: img07, title: 'Stickers', subtitle: 'Prácticas y versátiles siempre.' },
    { img: img08, title: 'Resellables', subtitle: 'Abre, cierra y reutiliza.' },
    { img: img09, title: 'Scratch Off', subtitle: 'Rasca y descubre sorpresas.' },
    { img: img10, title: 'Cold Foil', subtitle: 'Toque metálico y premium.' },
    { img: img11, title: 'Con Aroma', subtitle: 'Fragancia que atrae sentidos.' },
    { img: img12, title: 'Holográficas', subtitle: 'Colores que cambian y brillan.' },
    { img: img13, title: 'Nylon', subtitle: 'Duraderas, flexibles y resistentes.' },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);

    // Detectar si es móvil y actualizar state
    const checkMobile = () => {
      setIsMobileView(window.innerWidth <= 576);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);

    // Efecto Parallax con GSAP
    const hero = heroRef.current;
    const labelsLeft = labelsLeftRef.current;
    const labelsRight = labelsRightRef.current;
    const labelCenter = labelCenterRef.current;

    const heroSection = document.querySelector('.hero-section-etiquetas');

    // Animación inicial de entrada para las etiquetas (aparecen de arriba hacia abajo)
    // Orden: label-left-1, label-right-1, label-left-2, label-right-2, label-left-3, label-right-3, label-center
    const orderedLabels = [
      labelsLeft[0],  // label-left-1 (arriba izquierda)
      labelsRight[0], // label-right-1 (arriba derecha)
      labelsLeft[1],  // label-left-2 (medio izquierda)
      labelsRight[1], // label-right-2 (medio derecha)
      labelsLeft[2],  // label-left-3 (abajo izquierda)
      labelsRight[2], // label-right-3 (abajo derecha)
      labelCenter,    // label-center (café)
    ];

    orderedLabels.forEach((label, index) => {
      if (label) {
        // Establecer estado inicial invisible
        gsap.set(label, { opacity: 0, y: 50 });

        // Animar la entrada con delay escalonado de arriba hacia abajo
        gsap.to(label, {
          opacity: 1,
          y: 0,
          duration: 1,
          delay: 0.5 + (index * 0.15), // Cada imagen aparece 0.15s después de la anterior
          ease: 'power3.out',
        });
      }
    });

    // Para el parallax, usamos todas las etiquetas
    const allLabels = [...labelsLeft, ...labelsRight, labelCenter];

    if (heroSection && hero) {
      // Detectar si es móvil para ajustar el parallax
      const isMobile = window.innerWidth <= 768;
      const parallaxDistance = isMobile ? -250 : -500;
      const parallaxScrub = isMobile ? 1 : 0.3;

      // Hero se mueve MUCHÍSIMO más lento (casi fijo)
      gsap.to(hero, {
        y: 100,
        ease: 'none',
        scrollTrigger: {
          trigger: heroSection,
          start: 'top top',
          end: 'bottom bottom',
          scrub: 8,
        },
      });

      // Etiquetas y textos suben MUCHO más rápido (parallax al hacer scroll)
      allLabels.forEach((label) => {
        if (label) {
          gsap.to(label, {
            y: parallaxDistance,
            ease: 'none',
            scrollTrigger: {
              trigger: heroSection,
              start: 'top top',
              end: 'bottom bottom',
              scrub: parallaxScrub,
            },
          });
        }
      });
    }

    // Scroll Horizontal del Carrusel - Enfoque Simple
    const carousel = carouselRef.current;
    const carouselContainer = carouselContainerRef.current;

    if (carousel && carouselContainer) {
      const slides = carousel.querySelectorAll('.carousel-slide');
      const totalSlides = slides.length;

      // Configurar el estado inicial
      const isMobileDevice = window.innerWidth <= 768;

      slides.forEach((slide, index) => {
        const img = slide.querySelector('img');
        if (img) {
          if (isMobileDevice) {
            // En móvil: todas las imágenes al mismo tamaño (sin efecto de scale)
            gsap.set(img, { scale: 1 });
          } else {
            // En desktop: primer producto scale 1, el resto scale 0.6
            if (index === 0) {
              gsap.set(img, { scale: 1 });
            } else {
              gsap.set(img, { scale: 0.6 });
            }
          }
        }
      });

      // Calcular slideWidth basado en el tamaño de pantalla
      const windowWidth = window.innerWidth;
      let slideWidthVW;
      let gapVW;

      if (windowWidth <= 576) {
        slideWidthVW = 0.85; // 85vw en móvil
        gapVW = 0.03; // 3vw en móvil
      } else if (windowWidth <= 768) {
        slideWidthVW = 0.7; // 70vw en tablet portrait
        gapVW = 0.04; // 4vw
      } else if (windowWidth <= 992) {
        slideWidthVW = 0.6; // 60vw en tablet
        gapVW = 0.04; // 4vw
      } else {
        slideWidthVW = 0.44; // 44vw en desktop
        gapVW = 0.04; // 4vw
      }

      // Obtener el ancho real del primer slide para ser más preciso
      const firstSlide = slides[0];
      const firstSlideRect = firstSlide.getBoundingClientRect();
      const actualSlideWidth = firstSlideRect.width;
      const gapPx = windowWidth * gapVW;
      const slideStep = actualSlideWidth + gapPx;
      const totalScrollDistance = slideStep * (totalSlides - 1);

      // Animación horizontal del carrusel
      const carouselAnimation = gsap.to(carousel, {
        x: () => -totalScrollDistance,
        ease: 'none',
        scrollTrigger: {
          trigger: carouselContainer,
          pin: true,
          start: 'top top',
          end: () => `+=${totalScrollDistance * 2}`,
          scrub: 1,
          snap: {
            snapTo: 1 / (totalSlides - 1),
            duration: 0.4,
            ease: 'power2.inOut',
          },
          onUpdate: () => {
            // Calcular cuál slide está centrado basándose en el desplazamiento actual
            const currentX = Math.abs(gsap.getProperty(carousel, 'x'));
            const centeredSlideIndex = Math.round(currentX / slideStep);
            const clampedIndex = Math.min(Math.max(centeredSlideIndex, 0), totalSlides - 1);

            setCurrentSlide(clampedIndex);

            // Aplicar scale solo en desktop
            if (!isMobileDevice) {
              slides.forEach((slide, index) => {
                const img = slide.querySelector('img');
                if (img) {
                  // El slide actual (centrado) tiene scale 1, los demás 0.6 (40% más pequeños)
                  if (index === clampedIndex) {
                    gsap.to(img, { scale: 1, duration: 0.3, ease: 'power2.out' });
                  } else {
                    gsap.to(img, { scale: 0.6, duration: 0.3, ease: 'power2.out' });
                  }
                }
              });
            }
          },
        },
      });

      return () => {
        carouselAnimation.scrollTrigger?.kill();
      };
    }

    // Animaciones de la sección de características
    const caracteristicasTitle = caracteristicasTitleRef.current;
    const caracteristicasImage = caracteristicasImageRef.current;
    const caracteristicasItems = caracteristicasItemsRef.current;

    if (caracteristicasTitle) {
      gsap.fromTo(
        caracteristicasTitle,
        { y: 100, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: caracteristicasTitle,
            start: 'top 80%',
            end: 'top 50%',
            toggleActions: 'play none none none',
          },
        }
      );
    }

    if (caracteristicasImage) {
      gsap.fromTo(
        caracteristicasImage,
        { y: 100, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: caracteristicasImage,
            start: 'top 80%',
            end: 'top 50%',
            toggleActions: 'play none none none',
          },
        }
      );
    }

    // Animar cada item de características individualmente
    caracteristicasItems.forEach((item, index) => {
      if (item) {
        gsap.fromTo(
          item,
          { y: 100, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 1,
            delay: index * 0.2,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: item,
              start: 'top 85%',
              end: 'top 60%',
              toggleActions: 'play none none none',
            },
          }
        );
      }
    });

    // Animar CTA final de características
    const caracteristicasCTA = caracteristicasCTARef.current;
    if (caracteristicasCTA) {
      gsap.fromTo(
        caracteristicasCTA,
        { y: 100, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: caracteristicasCTA,
            start: 'top 85%',
            end: 'top 60%',
            toggleActions: 'play none none none',
          },
        }
      );
    }

    // Animaciones de la sección de sistemas de impresión
    const impresionTitle = impresionTitleRef.current;
    const impresionCards = impresionCardsRef.current;

    if (impresionTitle) {
      gsap.fromTo(
        impresionTitle,
        { y: 100, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: impresionTitle,
            start: 'top 80%',
            end: 'top 50%',
            toggleActions: 'play none none none',
          },
        }
      );
    }

    // Animar cada tarjeta de impresión individualmente
    impresionCards.forEach((card, index) => {
      if (card) {
        gsap.fromTo(
          card,
          { y: 100, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 1,
            delay: index * 0.2,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: card,
              start: 'top 85%',
              end: 'top 60%',
              toggleActions: 'play none none none',
            },
          }
        );
      }
    });

    // Animar CTA final de impresión
    const impresionCTA = impresionCTARef.current;
    if (impresionCTA) {
      gsap.fromTo(
        impresionCTA,
        { y: 100, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: impresionCTA,
            start: 'top 85%',
            end: 'top 60%',
            toggleActions: 'play none none none',
          },
        }
      );
    }

    return () => {
      window.removeEventListener('resize', checkMobile);
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return (
    <div className="landing-etiquetas">
      {/* Hero Section */}
      <section className="hero-section-etiquetas" style={{
        minHeight: '124vh',
        backgroundColor: '#000000',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        color: 'white',
        textAlign: 'center',
        padding: '2rem',
        paddingTop: '20vh',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Etiquetas Lado Izquierdo */}
        <div className="label-left-1" style={{ position: 'absolute', zIndex: 10 }}>
          <img
            ref={el => labelsLeftRef.current[0] = el}
            src={diamanteHolografico}
            alt="Diamante Holográfico"
            style={{ width: '270px', marginBottom: '3rem', transform: 'rotate(-8deg)' }}
          />
        </div>
        <div className="label-left-2" style={{ position: 'absolute', zIndex: 10 }}>
          <img
            ref={el => labelsLeftRef.current[1] = el}
            src={stickerMetalico}
            alt="Sticker Metálico"
            style={{ width: '252px', marginBottom: '3rem', transform: 'rotate(5deg)' }}
          />
        </div>
        <div className="label-left-3" style={{ position: 'absolute', zIndex: 10 }}>
          <img
            ref={el => labelsLeftRef.current[2] = el}
            src={jamon}
            alt="Etiqueta Jamón"
            style={{ width: '288px', transform: 'rotate(-3deg)' }}
          />
        </div>

        {/* Etiquetas Lado Derecho */}
        <div className="label-right-1" style={{ position: 'absolute', zIndex: 10 }}>
          <img
            ref={el => labelsRightRef.current[0] = el}
            src={transparente}
            alt="Etiqueta Transparente"
            style={{ width: '261px', marginBottom: '3rem', transform: 'rotate(6deg)' }}
          />
        </div>
        <div className="label-right-2" style={{ position: 'absolute', zIndex: 10 }}>
          <img
            ref={el => labelsRightRef.current[1] = el}
            src={glowindarkAlien}
            alt="Glow in Dark Alien"
            style={{ width: '279px', marginBottom: '3rem', transform: 'rotate(-7deg)' }}
          />
        </div>
        <div className="label-right-3" style={{ position: 'absolute', zIndex: 10 }}>
          <img
            ref={el => labelsRightRef.current[2] = el}
            src={metalico_Crema}
            alt="Metálico Crema"
            style={{ width: '270px', transform: 'rotate(4deg)' }}
          />
        </div>

        {/* Etiqueta Centro - Café */}
        <div className="label-center" style={{ position: 'absolute', top: '85vh', left: '50%', transform: 'translateX(-50%)', zIndex: 10 }}>
          <img
            ref={labelCenterRef}
            src={cafe}
            alt="Vaso Café"
            style={{ width: '324px', transform: 'rotate(-2deg)' }}
          />
        </div>

        {/* Textos adicionales debajo del café (capa etiquetas) */}
        <div ref={el => labelsLeftRef.current[3] = el} style={{
          position: 'absolute',
          top: isMobileView ? '160vh' : '140vh',
          left: '0',
          right: '0',
          zIndex: 10,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          padding: '0 2rem'
        }}>
          <h2 style={{
            fontSize: 'clamp(2.5rem, 5vw, 4.5rem)',
            fontWeight: '700',
            marginBottom: '0.5rem',
            fontFamily: 'Manrope, sans-serif',
            color: 'white',
            lineHeight: '1.2',
            maxWidth: '900px',
            margin: '0 auto 0.5rem'
          }}>
            Para todo tipo de ideas,
          </h2>
          <h2 style={{
            fontSize: 'clamp(2.5rem, 5vw, 4.5rem)',
            fontWeight: '700',
            marginBottom: '2rem',
            fontFamily: 'Manrope, sans-serif',
            color: '#C72027',
            lineHeight: '1.2',
            maxWidth: '900px',
            margin: '0 auto 2rem'
          }}>
            hay una etiqueta.
          </h2>
          <p style={{
            fontSize: 'clamp(1rem, 2vw, 1.3rem)',
            color: 'white',
            fontWeight: '400',
            margin: '0 auto'
          }}>
            Conoce nuestra variedad
          </p>
        </div>

        {/* Contenido del Hero (capa inferior) */}
        <div className="container" ref={heroRef} style={{ position: 'relative', zIndex: 5 }}>
          <h1 style={{
            fontSize: 'clamp(2.5rem, 5vw, 4.5rem)',
            fontWeight: '700',
            marginBottom: '0.5rem',
            fontFamily: 'Manrope, sans-serif',
            color: 'white',
            lineHeight: '1.2',
            maxWidth: '900px',
            margin: '0 auto 0.5rem'
          }}>
            No es solo una etiqueta.
          </h1>
          <h2 style={{
            fontSize: 'clamp(2rem, 4.5vw, 4rem)',
            fontWeight: '700',
            marginBottom: '2.5rem',
            fontFamily: 'Manrope, sans-serif',
            color: '#C72027',
            lineHeight: '1.3',
            maxWidth: '900px',
            margin: '0 auto 2.5rem'
          }}>
            Es la primera impresión de tu marca.
          </h2>
          <a
            href="https://wa.link/9qu07v"
            aria-label="Chatea con nosotros por WhatsApp"
            rel="noopener noreferrer"
            target="_blank"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              backgroundColor: 'white',
              color: '#000000',
              padding: '0.75rem 1.75rem',
              fontSize: '0.95rem',
              border: 'none',
              borderRadius: '50px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              fontWeight: '600',
              textDecoration: 'none',
              boxShadow: '0 4px 15px rgba(255, 255, 255, 0.2)'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#f0f0f0';
              e.target.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'white';
              e.target.style.transform = 'scale(1)';
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#000000" className="bi bi-whatsapp" viewBox="0 0 16 16">
              <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
            </svg>
            Empecemos con tu marca
          </a>
        </div>
      </section>

      {/* Sección Carrusel Horizontal */}
      <section
        ref={carouselContainerRef}
        style={{
          height: '100vh',
          background: 'linear-gradient(to bottom, #000000 0%, #2d2d2d 33%, #3a3a3a 50%, #2d2d2d 66%, #000000 100%)',
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {/* Contenedor de slides que se mueve horizontalmente */}
        <div
          ref={carouselRef}
          className="carousel-container"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '4vw',
          }}
        >
          {carouselData.map((item, index) => (
            <div
              key={index}
              className="carousel-slide"
              data-index={index}
              style={{
                minWidth: '44vw',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <img
                src={item.img}
                alt={item.title}
                style={{
                  height: '55vh',
                  width: 'auto',
                  objectFit: 'contain',
                  transition: 'transform 0.5s ease-out',
                }}
              />
            </div>
          ))}
        </div>

        {/* Overlay fijo para títulos (no se mueve) */}
        <div
          style={{
            position: 'absolute',
            bottom: '15vh',
            left: '0',
            right: '0',
            textAlign: 'center',
            pointerEvents: 'none',
            zIndex: 10,
          }}
        >
          {carouselData.map((item, index) => (
            <div
              key={`title-${index}`}
              style={{
                position: 'absolute',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '100%',
                opacity: currentSlide === index ? 1 : 0,
                transition: 'opacity 0.5s ease-in-out',
              }}
            >
              <h2
                className="carousel-title"
                style={{
                  fontSize: 'clamp(2rem, 4vw, 3.5rem)',
                  fontWeight: '700',
                  color: 'white',
                  marginBottom: '1rem',
                  fontFamily: 'Manrope, sans-serif',
                }}
              >
                {item.title}
              </h2>
              <p
                className="carousel-subtitle"
                style={{
                  fontSize: 'clamp(1rem, 2vw, 1.5rem)',
                  color: 'white',
                  fontFamily: 'Manrope, sans-serif',
                  fontWeight: '400',
                }}
              >
                {item.subtitle}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Sección de Sectores */}
      <section style={{
        padding: '5rem 2rem',
        backgroundColor: '#000000',
        color: 'white',
      }}>
        <div className="container">
          {/* Título */}
          <h2 style={{
            fontSize: 'clamp(2rem, 4vw, 3.5rem)',
            fontWeight: '700',
            marginBottom: '0.5rem',
            fontFamily: 'Manrope, sans-serif',
            color: 'white',
            textAlign: 'center',
            lineHeight: '1.2',
          }}>
            Sin importa a qué te dediques,
          </h2>
          <h2 style={{
            fontSize: 'clamp(2rem, 4vw, 3.5rem)',
            fontWeight: '700',
            marginBottom: '3rem',
            fontFamily: 'Manrope, sans-serif',
            color: '#C72027',
            textAlign: 'center',
            lineHeight: '1.2',
          }}>
            hay una etiqueta para ti.
          </h2>

          {/* Grid de sectores */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 376px))',
            gap: '1.5rem',
            justifyContent: 'center',
            maxWidth: '1200px',
            margin: '0 auto',
          }}>
            {/* Fila 1 */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1.5rem',
              backgroundColor: '#3a3a3a',
              borderRadius: '20px',
              padding: '1.5rem 2rem',
              height: '116px',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              cursor: 'pointer',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 8px 20px rgba(199, 32, 39, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <img src={iconoAlimentos} alt="Alimentos y Bebidas" style={{ width: '60px', height: '60px', objectFit: 'contain' }} />
              <span style={{ fontSize: '1.25rem', fontWeight: '600', color: 'white' }}>Sector Alimentos y Bebidas</span>
            </div>

            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1.5rem',
              backgroundColor: '#3a3a3a',
              borderRadius: '20px',
              padding: '1.5rem 2rem',
              height: '116px',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              cursor: 'pointer',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 8px 20px rgba(199, 32, 39, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <img src={iconoFarmaceutico} alt="Farmacéutico" style={{ width: '60px', height: '60px', objectFit: 'contain' }} />
              <span style={{ fontSize: '1.25rem', fontWeight: '600', color: 'white' }}>Sector Farmacéutico</span>
            </div>

            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1.5rem',
              backgroundColor: '#3a3a3a',
              borderRadius: '20px',
              padding: '1.5rem 2rem',
              height: '116px',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              cursor: 'pointer',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 8px 20px rgba(199, 32, 39, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <img src={iconoAnimal} alt="Animal" style={{ width: '60px', height: '60px', objectFit: 'contain' }} />
              <span style={{ fontSize: '1.25rem', fontWeight: '600', color: 'white' }}>Sector Animal</span>
            </div>

            {/* Fila 2 */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1.5rem',
              backgroundColor: '#3a3a3a',
              borderRadius: '20px',
              padding: '1.5rem 2rem',
              height: '116px',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              cursor: 'pointer',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 8px 20px rgba(199, 32, 39, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <img src={iconoBelleza} alt="Belleza" style={{ width: '60px', height: '60px', objectFit: 'contain' }} />
              <span style={{ fontSize: '1.25rem', fontWeight: '600', color: 'white' }}>Sector Belleza</span>
            </div>

            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1.5rem',
              backgroundColor: '#3a3a3a',
              borderRadius: '20px',
              padding: '1.5rem 2rem',
              height: '116px',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              cursor: 'pointer',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 8px 20px rgba(199, 32, 39, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <img src={iconoManufacturero} alt="Manufacturero" style={{ width: '60px', height: '60px', objectFit: 'contain' }} />
              <span style={{ fontSize: '1.25rem', fontWeight: '600', color: 'white' }}>Sector Manufacturero</span>
            </div>

            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1.5rem',
              backgroundColor: '#3a3a3a',
              borderRadius: '20px',
              padding: '1.5rem 2rem',
              height: '116px',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              cursor: 'pointer',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 8px 20px rgba(199, 32, 39, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <img src={iconoAutomotriz} alt="Automotriz" style={{ width: '60px', height: '60px', objectFit: 'contain' }} />
              <span style={{ fontSize: '1.25rem', fontWeight: '600', color: 'white' }}>Sector Automotriz</span>
            </div>

            {/* Fila 3 */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1.5rem',
              backgroundColor: '#3a3a3a',
              borderRadius: '20px',
              padding: '1.5rem 2rem',
              height: '116px',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              cursor: 'pointer',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 8px 20px rgba(199, 32, 39, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <img src={iconoIndustrial} alt="Industrial" style={{ width: '60px', height: '60px', objectFit: 'contain' }} />
              <span style={{ fontSize: '1.25rem', fontWeight: '600', color: 'white' }}>Sector Industrial</span>
            </div>

            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1.5rem',
              backgroundColor: '#3a3a3a',
              borderRadius: '20px',
              padding: '1.5rem 2rem',
              height: '116px',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              cursor: 'pointer',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 8px 20px rgba(199, 32, 39, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <img src={iconoVinos} alt="Vinos y Licores" style={{ width: '60px', height: '60px', objectFit: 'contain' }} />
              <span style={{ fontSize: '1.25rem', fontWeight: '600', color: 'white' }}>Sector de Vinos y Licores</span>
            </div>

            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1.5rem',
              backgroundColor: '#3a3a3a',
              borderRadius: '20px',
              padding: '1.5rem 2rem',
              height: '116px',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              cursor: 'pointer',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 8px 20px rgba(199, 32, 39, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <img src={iconoTextiles} alt="Textiles" style={{ width: '60px', height: '60px', objectFit: 'contain' }} />
              <span style={{ fontSize: '1.25rem', fontWeight: '600', color: 'white' }}>Textiles</span>
            </div>

            {/* Fila 4 */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1.5rem',
              backgroundColor: '#3a3a3a',
              borderRadius: '20px',
              padding: '1.5rem 2rem',
              height: '116px',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              cursor: 'pointer',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 8px 20px rgba(199, 32, 39, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <img src={iconoPinturas} alt="Pinturas" style={{ width: '60px', height: '60px', objectFit: 'contain' }} />
              <span style={{ fontSize: '1.25rem', fontWeight: '600', color: 'white' }}>Pinturas</span>
            </div>

            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1.5rem',
              backgroundColor: '#3a3a3a',
              borderRadius: '20px',
              padding: '1.5rem 2rem',
              height: '116px',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              cursor: 'pointer',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 8px 20px rgba(199, 32, 39, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <img src={iconoOtros} alt="Otras industrias" style={{ width: '60px', height: '60px', objectFit: 'contain' }} />
              <span style={{ fontSize: '1.25rem', fontWeight: '600', color: 'white' }}>Otras industrias</span>
            </div>
          </div>

          {/* Texto y botón al final */}
          <div style={{
            textAlign: 'center',
            marginTop: '4rem',
          }}>
            <p style={{
              fontSize: 'clamp(1.5rem, 3vw, 2rem)',
              fontWeight: '400',
              color: 'white',
              marginBottom: '0.5rem',
              fontFamily: 'Manrope, sans-serif',
            }}>
              Permanentes, removibles o reposicionables...
            </p>
            <h3 style={{
              fontSize: 'clamp(2rem, 4vw, 3rem)',
              fontWeight: '700',
              color: 'white',
              marginBottom: '2rem',
              fontFamily: 'Manrope, sans-serif',
            }}>
              tú eliges la etiqueta que va contigo.
            </h3>
            <a
              href="https://wa.link/9qu07v"
              aria-label="Elige tu etiqueta por WhatsApp"
              rel="noopener noreferrer"
              target="_blank"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem',
                backgroundColor: '#C72027',
                color: 'white',
                padding: '1rem 2rem',
                fontSize: '1.1rem',
                border: 'none',
                borderRadius: '50px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                fontWeight: '600',
                textDecoration: 'none',
                boxShadow: '0 4px 15px rgba(199, 32, 39, 0.4)'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#a51a1f';
                e.target.style.transform = 'scale(1.05)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#C72027';
                e.target.style.transform = 'scale(1)';
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" className="bi bi-whatsapp" viewBox="0 0 16 16">
                <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
              </svg>
              Elige tu etiqueta
            </a>
          </div>
        </div>
      </section>

      {/* Sección de Características */}
      <section style={{
        padding: '5rem 2rem',
        backgroundColor: '#f5f5f5',
      }}>
        <div className="container">
          {/* Título */}
          <div ref={caracteristicasTitleRef} style={{ textAlign: 'center', marginBottom: '4rem' }}>
            <h2 style={{
              fontSize: 'clamp(2.5rem, 5vw, 4rem)',
              fontWeight: '700',
              marginBottom: '0.5rem',
              fontFamily: 'Manrope, sans-serif',
              color: '#1a1a1a',
              lineHeight: '1.2',
            }}>
              Lo que una buena etiqueta
            </h2>
            <h2 style={{
              fontSize: 'clamp(2.5rem, 5vw, 4rem)',
              fontWeight: '700',
              fontFamily: 'Manrope, sans-serif',
              color: '#C72027',
              lineHeight: '1.2',
            }}>
              sí o sí debe tener.
            </h2>
          </div>

          {/* Contenido */}
          <div className="row align-items-center">
            {/* Columna izquierda - Imágenes */}
            <div className="col-md-6 mb-4 mb-md-0">
              <div ref={caracteristicasImageRef} style={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '500px',
              }}>
                <img
                  src={holograficoImg}
                  alt="Producto holográfico"
                  style={{
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    width: 'auto',
                    height: '450px',
                    objectFit: 'contain',
                    transform: 'translate(-65%, -60%) rotate(-8deg)',
                    zIndex: 1,
                  }}
                />
                <img
                  src={frascoImg}
                  alt="Frasco con etiqueta"
                  style={{
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    width: 'auto',
                    height: '350px',
                    objectFit: 'contain',
                    transform: 'translate(10%, -50%) rotate(8deg)',
                    zIndex: 2,
                  }}
                />
              </div>
            </div>

            {/* Columna derecha - Lista de características */}
            <div className="col-md-6">
              {/* Item 1 */}
              <div
                ref={el => caracteristicasItemsRef.current[0] = el}
                style={{
                  display: 'flex',
                  gap: '1rem',
                  marginBottom: '2rem',
                  alignItems: 'flex-start',
                }}
              >
                <div style={{
                  minWidth: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: '#C72027',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.6666 5L7.49992 14.1667L3.33325 10" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div>
                  <h4 style={{
                    fontSize: '1.25rem',
                    fontWeight: '700',
                    color: '#1a1a1a',
                    marginBottom: '0.5rem',
                    fontFamily: 'Manrope, sans-serif',
                  }}>
                    Personalizadas a tu estilo:
                  </h4>
                  <p style={{
                    fontSize: '1.1rem',
                    color: '#787A7D',
                    lineHeight: '1.6',
                    margin: 0,
                  }}>
                    desde los colores hasta los acabados.
                  </p>
                </div>
              </div>

              {/* Item 2 */}
              <div
                ref={el => caracteristicasItemsRef.current[1] = el}
                style={{
                  display: 'flex',
                  gap: '1rem',
                  marginBottom: '2rem',
                  alignItems: 'flex-start',
                }}
              >
                <div style={{
                  minWidth: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: '#C72027',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.6666 5L7.49992 14.1667L3.33325 10" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div>
                  <h4 style={{
                    fontSize: '1.25rem',
                    fontWeight: '700',
                    color: '#1a1a1a',
                    marginBottom: '0.5rem',
                    fontFamily: 'Manrope, sans-serif',
                  }}>
                    Versátiles
                  </h4>
                  <p style={{
                    fontSize: '1.1rem',
                    color: '#787A7D',
                    lineHeight: '1.6',
                    margin: 0,
                  }}>
                    a la idea que tengas.
                  </p>
                </div>
              </div>

              {/* Item 3 */}
              <div
                ref={el => caracteristicasItemsRef.current[2] = el}
                style={{
                  display: 'flex',
                  gap: '1rem',
                  marginBottom: '2rem',
                  alignItems: 'flex-start',
                }}
              >
                <div style={{
                  minWidth: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: '#C72027',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.6666 5L7.49992 14.1667L3.33325 10" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div>
                  <h4 style={{
                    fontSize: '1.25rem',
                    fontWeight: '700',
                    color: '#1a1a1a',
                    marginBottom: '0.5rem',
                    fontFamily: 'Manrope, sans-serif',
                  }}>
                    Hechas para durar sin importar el entorno:
                  </h4>
                  <p style={{
                    fontSize: '1.1rem',
                    color: '#787A7D',
                    lineHeight: '1.6',
                    margin: 0,
                  }}>
                    a la abrasión, al desgaste, a la temperatura y demás usos.
                  </p>
                </div>
              </div>

              {/* Item 4 */}
              <div
                ref={el => caracteristicasItemsRef.current[3] = el}
                style={{
                  display: 'flex',
                  gap: '1rem',
                  alignItems: 'flex-start',
                }}
              >
                <div style={{
                  minWidth: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: '#C72027',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.6666 5L7.49992 14.1667L3.33325 10" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div>
                  <h4 style={{
                    fontSize: '1.25rem',
                    fontWeight: '700',
                    color: '#1a1a1a',
                    marginBottom: '0.5rem',
                    fontFamily: 'Manrope, sans-serif',
                  }}>
                    Las entregamos en el formato que necesites:
                  </h4>
                  <p style={{
                    fontSize: '1.1rem',
                    color: '#787A7D',
                    lineHeight: '1.6',
                    margin: 0,
                  }}>
                    en rollo o en fajilla.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA final */}
          <div ref={caracteristicasCTARef} style={{
            textAlign: 'center',
            marginTop: '5rem',
          }}>
            <p style={{
              fontSize: 'clamp(1.5rem, 3vw, 2rem)',
              fontWeight: '400',
              color: '#1a1a1a',
              marginBottom: '0.5rem',
              fontFamily: 'Manrope, sans-serif',
            }}>
              Ahora solo falta una cosa:
            </p>
            <h3 style={{
              fontSize: 'clamp(2rem, 4vw, 3rem)',
              fontWeight: '700',
              color: '#1a1a1a',
              marginBottom: '2rem',
              fontFamily: 'Manrope, sans-serif',
            }}>
              empezar a trabajar con tu marca.
            </h3>
            <a
              href="https://wa.link/9qu07v"
              aria-label="Hablemos de tu proyecto por WhatsApp"
              rel="noopener noreferrer"
              target="_blank"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem',
                backgroundColor: '#C72027',
                color: 'white',
                padding: '1rem 2rem',
                fontSize: '1.1rem',
                border: 'none',
                borderRadius: '50px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                fontWeight: '600',
                textDecoration: 'none',
                boxShadow: '0 4px 15px rgba(199, 32, 39, 0.4)'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#a51a1f';
                e.target.style.transform = 'scale(1.05)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#C72027';
                e.target.style.transform = 'scale(1)';
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" className="bi bi-whatsapp" viewBox="0 0 16 16">
                <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
              </svg>
              Hablemos de tu proyecto
            </a>
          </div>
        </div>
      </section>

      {/* Sección de Sistemas de Impresión */}
      <section style={{
        padding: '5rem 2rem',
        backgroundColor: 'white',
      }}>
        <div className="container">
          {/* Título y descripción */}
          <div ref={impresionTitleRef} style={{ textAlign: 'center', marginBottom: '4rem' }}>
            <h2 style={{
              fontSize: 'clamp(2.5rem, 5vw, 4rem)',
              fontWeight: '700',
              marginBottom: '1rem',
              fontFamily: 'Manrope, sans-serif',
              color: '#1a1a1a',
              lineHeight: '1.2',
            }}>
              ¿Tienes una idea?
            </h2>
            <h3 style={{
              fontSize: 'clamp(2.5rem, 5vw, 4rem)',
              fontWeight: '700',
              marginBottom: '2rem',
              fontFamily: 'Manrope, sans-serif',
              color: '#C72027',
              lineHeight: '1.2',
            }}>
              Nos encargamos de imprimirla
            </h3>
            <p style={{
              fontSize: 'clamp(1rem, 2vw, 1.25rem)',
              color: '#787A7D',
              lineHeight: '1.8',
              maxWidth: '900px',
              margin: '0 auto',
            }}>
              En Mega Label nos especializamos en la impresión de etiquetas con un nivel excepcional de detalle y acabados premium que elevan la presentación de tus productos. Descubre nuestros sistemas de impresión y la tecnología que hace posible cada resultado.
            </p>
          </div>

          {/* Grid de tarjetas */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '2rem',
            maxWidth: '1200px',
            margin: '0 auto',
          }}>
            {/* Tarjeta Flexográfica */}
            <div
              ref={el => impresionCardsRef.current[0] = el}
              style={{
                position: 'relative',
                borderRadius: '20px',
                overflow: 'hidden',
                height: '500px',
                cursor: 'pointer',
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.1)';
              }}
            >
              <img
                src={flexoImg}
                alt="Flexográfica"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
              <div style={{
                position: 'absolute',
                bottom: '0',
                left: '0',
                right: '0',
                padding: '2rem',
                background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.4) 70%, transparent 100%)',
              }}>
                <h4 style={{
                  fontSize: 'clamp(1.75rem, 3vw, 2.25rem)',
                  fontWeight: '700',
                  color: 'white',
                  marginBottom: '0.5rem',
                  fontFamily: 'Manrope, sans-serif',
                }}>
                  Flexográfica
                </h4>
                <p style={{
                  fontSize: '1.1rem',
                  color: 'white',
                  lineHeight: '1.6',
                  margin: 0,
                }}>
                  Sistema ideal para grandes volúmenes y capaz de imprimir con hasta 8 tintas.
                </p>
              </div>
            </div>

            {/* Tarjeta Digital */}
            <div
              ref={el => impresionCardsRef.current[1] = el}
              style={{
                position: 'relative',
                borderRadius: '20px',
                overflow: 'hidden',
                height: '500px',
                cursor: 'pointer',
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.1)';
              }}
            >
              <img
                src={digitalImg}
                alt="Digital"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
              <div style={{
                position: 'absolute',
                bottom: '0',
                left: '0',
                right: '0',
                padding: '2rem',
                background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.4) 70%, transparent 100%)',
              }}>
                <h4 style={{
                  fontSize: 'clamp(1.75rem, 3vw, 2.25rem)',
                  fontWeight: '700',
                  color: 'white',
                  marginBottom: '0.5rem',
                  fontFamily: 'Manrope, sans-serif',
                }}>
                  Digital
                </h4>
                <p style={{
                  fontSize: '1.1rem',
                  color: 'white',
                  lineHeight: '1.6',
                  margin: 0,
                }}>
                  Perfecta para tirajes cortos y personalización avanzada.
                </p>
              </div>
            </div>

            {/* Tarjeta Híbrida */}
            <div
              ref={el => impresionCardsRef.current[2] = el}
              style={{
                position: 'relative',
                borderRadius: '20px',
                overflow: 'hidden',
                height: '500px',
                cursor: 'pointer',
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.1)';
              }}
            >
              <img
                src={hibridaImg}
                alt="Híbrida"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
              <div style={{
                position: 'absolute',
                bottom: '0',
                left: '0',
                right: '0',
                padding: '2rem',
                background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.4) 70%, transparent 100%)',
              }}>
                <h4 style={{
                  fontSize: 'clamp(1.75rem, 3vw, 2.25rem)',
                  fontWeight: '700',
                  color: 'white',
                  marginBottom: '0.5rem',
                  fontFamily: 'Manrope, sans-serif',
                }}>
                  Híbrida
                </h4>
                <p style={{
                  fontSize: '1.1rem',
                  color: 'white',
                  lineHeight: '1.6',
                  margin: 0,
                }}>
                  Combina lo mejor de ambos mundos: detalle, rapidez y eficiencia.
                </p>
              </div>
            </div>
          </div>

          {/* CTA final */}
          <div ref={impresionCTARef} style={{
            textAlign: 'center',
            marginTop: '5rem',
          }}>
            <p style={{
              fontSize: 'clamp(1.5rem, 3vw, 2rem)',
              fontWeight: '400',
              color: '#1a1a1a',
              marginBottom: '0.5rem',
              fontFamily: 'Manrope, sans-serif',
            }}>
              Imagina todo lo que podríamos hacer.
            </p>
            <h3 style={{
              fontSize: 'clamp(2rem, 4vw, 3rem)',
              fontWeight: '700',
              color: '#1a1a1a',
              marginBottom: '2rem',
              fontFamily: 'Manrope, sans-serif',
            }}>
              Transformemos tu marca.
            </h3>
            <a
              href="https://wa.link/9qu07v"
              aria-label="Imprimamos tu idea por WhatsApp"
              rel="noopener noreferrer"
              target="_blank"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem',
                backgroundColor: '#C72027',
                color: 'white',
                padding: '1rem 2rem',
                fontSize: '1.1rem',
                border: 'none',
                borderRadius: '50px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                fontWeight: '600',
                textDecoration: 'none',
                boxShadow: '0 4px 15px rgba(199, 32, 39, 0.4)'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#a51a1f';
                e.target.style.transform = 'scale(1.05)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#C72027';
                e.target.style.transform = 'scale(1)';
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" className="bi bi-whatsapp" viewBox="0 0 16 16">
                <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
              </svg>
              Imprimamos tu idea
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LandingEtiquetas;
